import { useAppDispatch } from "@/services/hooks";
import { useCurrentPermission } from "@/services/userServices/useCurrentPermission";
import React, { useCallback, useState } from "react";

import { updateProperty, clearMessage } from "@/services/productServices/productActions";
import UpdateOrderView from "./UpdateOrderView";
import type { PropertyRow } from "./UpdatePropertiesContainer";

export type UpdateOrderContainerProps = {
  propTpUpdate?: PropertyRow;
};

export default function UpdateOrderContainer({
  propTpUpdate,
}: UpdateOrderContainerProps) {
  const dispatch = useAppDispatch();

  const permission = useCurrentPermission();
  const canEdit = !!(permission?.edit || permission?.publish);
  const [draft, setDraft] = useState<PropertyRow>(
    propTpUpdate || { order_listing: "", order_product: "" }
  );

  const onChangeUpdateInput = useCallback((e) => {
    const { name, value } = e.target;
    // keep numeric but allow empty
    const next =
      value === "" ? "" : Number.isNaN(Number(value)) ? draft[name] : Number(value);
    setDraft((d) => ({ ...d, [name]: next }));
  }, [draft]);

  const onClickUpdate = useCallback(() => {
    dispatch(updateProperty({ _id: draft._id, property: draft }));
    dispatch(clearMessage());
  }, [dispatch, draft]);

  if (!canEdit) return null;

  return (
    <UpdateOrderView
      draft={draft}
      onChangeUpdateInput={onChangeUpdateInput}
      onClickUpdate={onClickUpdate}
    />
  );
}
